import { render, staticRenderFns } from "./rankmatch_user_list.vue?vue&type=template&id=f55295b6&scoped=true"
import script from "./rankmatch_user_list.vue?vue&type=script&lang=js"
export * from "./rankmatch_user_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55295b6",
  null
  
)

export default component.exports